import * as wjcCore from '@mescius/wijmo';
import * as wjInput from '@mescius/wijmo.input';

'use strict';

import {ViewChild, Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {Store} from "@ngrx/store";
import {ToasterService} from "angular2-toaster";
import {TranslocoService} from '@jsverse/transloco';
import {ActivePromotionConfig} from "../config/active-promotion.config";
import {asOrientDate, isOrientDate, DataService} from "@cosbeni/database";

;
import {Observable} from 'rxjs';
import {LoadUserAction} from "../ngrx/actions/user.action";

@Component({
    standalone: false,
    selector: 'cj-admin-preference',
    templateUrl: 'preference-management.component.html',
})

export class PreferenceManagementComponent {
    user: any;
    @ViewChild('buyerAutoComplete') buyerAutoComplete: wjInput.AutoComplete;
    @ViewChild('sellerAutoComplete') sellerAutoComplete: wjInput.AutoComplete;
    preference: any = {};
    mode: string = "view";
    optionAuction: any[] = [];
    optionAuctionResult: any[] = [];
    optionCategory: any[] = [];
    optionCorner: any[] = [];
    optionLane: any[] = [];
    optionPlace: any[] = [];
    optionUnit: any[] = [];

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private route: ActivatedRoute, private http: HttpClient, private transloco: TranslocoService) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("activePromotionFeature").subscribe((digitalAuction: any) => {
            if (wjcCore.isObject(digitalAuction.user)) {
                this.user = digitalAuction.user.user;
                this.dataService.query({
                    sql: "SELECT FROM DA_Preference WHERE username = '" + this.user.name + "'",
                    count: "SELECT FROM DA_Preference WHERE username = '" + this.user.name + "'",
                    fetchPlan: "*:1",
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (wjcCore.isArray(data.results) && data.results.length > 0) {
                        this.preference = Object.assign({}, data.results[0]);
                        if (wjcCore.isObject(this.preference.auction)) {
                            for(let auction of this.optionAuction){
                                if(auction['@rid']==this.preference.auction['@rid']){
                                    this.preference.auction = auction;
                                }
                            }
                        }
                        if (wjcCore.isObject(this.preference.buyer)) {
                            this.buyerAutoComplete.itemsSource = new wjcCore.CollectionView([this.preference.buyer]);
                        }
                        if (wjcCore.isObject(this.preference.seller)) {
                            this.sellerAutoComplete.itemsSource = new wjcCore.CollectionView([this.preference.seller]);
                        }
                    } else {
                        this.createNew();
                    }
                })
            }
        });
        this.dataService.query({
            sql: "SELECT FROM DA_Auction ORDER BY eventDate DESC",
            count: "SELECT FROM DA_Auction ORDER BY eventDate DESC",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                for(let auction of data.results){
                    if (isOrientDate(auction.eventDate)) {
                        auction.eventDate = asOrientDate(auction.eventDate);
                        auction.display = wjcCore.Globalize.formatDate(auction.eventDate, 'yyyy/MM/dd HH:mm:ss') + " " + auction.place + " " + auction.lane;
                    }
                }
                this.optionAuction = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='セリ結果' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='セリ結果' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionAuctionResult = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='商品種別' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='商品種別' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionCategory = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='コーナー名' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='コーナー名' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionCorner = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionLane = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionPlace = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='単位' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='単位' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionUnit = data.results;
            }
        })
    }

    createNew(): void {
        let today = new Date();
        let eventDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        this.preference = {
            "@class": "DA_Preference",
            "@rid": "#-1:-1",
            auctionPrice: 0,
            auctionResult: "未セリ",
            buyer: null,
            buyerCharge: 0.05,
            category: "",
            eventDate: eventDate,
            description: "",
            lane: "",
            minimumPrice: 0,
            name: "",
            place: "神戸",
            quantity: 1,
            seller: null,
            sellerCharge: 0.1,
            startPrice: 0,
            unit: "",
            username: this.user.name
        }
    }

    editPreference(): void {
        this.mode = "edit";
    }

    cancelPreference(): void {
        this.mode = "view";
        this.dataService.query({
            sql: "SELECT FROM DA_Preference WHERE username = '" + this.user.name + "'",
            count: "SELECT FROM DA_Preference WHERE username = '" + this.user.name + "'",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results) && data.results.length > 0) {
                this.preference = Object.assign({}, data.results[0]);
            } else {
                this.createNew();
            }
        })
    }

    savePreference(): void {
        this.savePreference$().subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('admin.saved_message'));
                this.dataService.query({
                    sql: "SELECT FROM DA_Preference WHERE username = '" + this.preference.username + "'",
                    count: "SELECT FROM DA_Preference WHERE username = '" + this.preference.username + "'",
                    fetchPlan: "*:1",
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (data.results.length == 1) {
                        this.preference = data.results[0];
                        if (wjcCore.isObject(this.preference.auction)) {
                            for(let auction of this.optionAuction){
                                if(auction['@rid']==this.preference.auction['@rid']){
                                    this.preference.auction = auction;
                                }
                            }
                        }
                        if (wjcCore.isObject(this.preference.buyer)) {
                            this.buyerAutoComplete.itemsSource = new wjcCore.CollectionView([this.preference.buyer]);
                        }
                        if (wjcCore.isObject(this.preference.seller)) {
                            this.sellerAutoComplete.itemsSource = new wjcCore.CollectionView([this.preference.seller]);
                        }
                        this.mode = "view";
                    }
                })
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('admin.failed_message'));
            }
        )
    }

    savePreference$(): Observable<any> {
        let preference = Object.assign({}, this.preference);
        if (wjcCore.isDate(preference.eventDate)) {
            preference.eventDate = wjcCore.Globalize.formatDate(preference.eventDate, 'yyyy-MM-dd');
        }
        let sql = "BEGIN\n"
        let mapItem: any[] = [];
        Object.entries(preference).forEach(([key, value]) => {
            if (wjcCore.isNumber(value) && !key.startsWith("@")) {
                if (key != "id" && value != 0) {
                    mapItem.push(key + "=" + value)
                }
            } else if (key == "buyer" || key == "seller"||key == "auction") {
                if (wjcCore.isObject(value)) {
                    mapItem.push(key + "=" + value['@rid'])
                } else {
                    mapItem.push(key + "=null")
                }
            } else {
                if (!key.startsWith("@") && value != null) {
                    if (wjcCore.isString(value)) {
                        let v: string = value;
                        v = v.replace(/\\/g, "\\\\");
                        v = v.replace(/\n/g, "\\n");
                        v = v.replace(/\t/g, "\\t");
                        v = v.replace(/'/g, "\\'");
                        v = v.replace(/"/g, '\\"');
                        value = v;
                    }
                    mapItem.push(key + "='" + value + "'")
                }
            }
        });
        if (preference['@rid'] == "#-1:-1") {
            sql = sql + "let preference = INSERT INTO DA_Preference SET " + mapItem.join(",") + " return $current\n";
        } else {
            sql = sql + "UPDATE DA_Preference SET " + mapItem.join(",") + " WHERE @rid = " + this.preference['@rid'] + "\n";
        }
        sql = sql + "COMMIT RETRY 100\n";
        return this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL);
    }

    getBuyerFunction(query: string, max: number, callback: Function) {
        if (!query) {
            callback(null);
            return;
        }
        let where = [];
        where.push("name LIKE '%" + query + "%'")
        where.push("memberName LIKE '%" + query + "%'")
        where.push("telephone LIKE '%" + query + "%'")
        this.dataService.query({
            sql: "SELECT FROM OUser WHERE status = 'ACTIVE' AND buyer = true AND (" + where.join(" OR ") + ")",
            count: "SELECT FROM OUser WHERE status = 'ACTIVE' AND buyer = true AND (" + where.join(" OR ") + ")",
            fetchPlan: "*:0",
        }, ActivePromotionConfig.SERVER_URL).subscribe(response => {
            if (wjcCore.isArray(response.results)) {
                callback(response.results);
            }
        })
    }

    getBuyer = this.getBuyerFunction.bind(this);

    getSellerFunction(query: string, max: number, callback: Function) {
        if (!query) {
            callback(null);
            return;
        }
        let where = [];
        where.push("name LIKE '%" + query + "%'")
        where.push("memberName LIKE '%" + query + "%'")
        where.push("telephone LIKE '%" + query + "%'")
        this.dataService.query({
            sql: "SELECT FROM OUser WHERE status = 'ACTIVE' AND seller = true AND (" + where.join(" OR ") + ")",
            count: "SELECT FROM OUser WHERE status = 'ACTIVE' AND seller = true AND (" + where.join(" OR ") + ")",
            fetchPlan: "*:0",
        }, ActivePromotionConfig.SERVER_URL).subscribe(response => {
            if (wjcCore.isArray(response.results)) {
                callback(response.results);
            }
        })
    }

    getSeller = this.getSellerFunction.bind(this);

}

